import { FC, useState, useRef } from "react";
import { Arrow, Title } from "./Section.styled";
import useClickOutside from "common/hooks/useClickOutside";
import Children from "./Children/Children";

interface Props {
  children: any;
  title: string;
}

const Section: FC<Props> = ({ title, children }) => {
  const [open, setOpen] = useState({
    [title]: false,
  });
  const mainEl = useRef(null);
  useClickOutside(mainEl, () =>
    setOpen({
      [title]: false,
    })
  );

  const handleToggle = () => {
    if (open[title]) {
      setOpen({ ...open, [title]: false });
    } else {
      setOpen({ ...open, [title]: true });
    }
  };
  return (
    <div ref={mainEl}>
      <Title open={open[title]}>
        <span style={{ display: "flex", alignContent: "center" }}>
          {" "}
          {title}
          <Arrow open={open[title]} onClick={handleToggle} />
        </span>
      </Title>
      <Children open={open[title]}>{children}</Children>
    </div>
  );
};

export default Section;
